import {FC, useEffect} from 'react'
import Card from '_core/components/Card'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from 'setup'
import {getDeliveryMethods} from 'app/features/orders/redux/shippingService/deliveryMethodsSlice'
import CustomerDeliveryMethod from '../CustomerDeliveryMethod'
import ShippingMethodList from './ShippingMethodList'

type Props = {
  order: any
}

const ShippingMethods: FC<Props> = ({order}) => {
  const dispatch = useDispatch()

  const totalWeight = useSelector<RootState>(
    ({orders}) => orders.fulfillment.order.totalWeight
  ) as number
  const shippingPackage = useSelector<RootState>(
    ({orders}) => orders.fulfillment.order.shippingDefinition.package
  ) as any

  const deliveryMethods = useSelector<RootState>(
    ({orders}) => orders.shippingService.deliveryMethods
  ) as any
  const {rates, noRates} = deliveryMethods

  useEffect(() => {
    if (totalWeight > 0 && shippingPackage && shippingPackage.id) {
      dispatch(getDeliveryMethods({totalWeight, order}))
    }
  }, [dispatch, totalWeight, shippingPackage, order])

  return (
    <Card title='Shipping Service' className='card-xl-stretch mb-5 mb-xl-8 pb-10'>
      <CustomerDeliveryMethod checkout={order.checkout} />
      {noRates && (
        <div className='alert bg-light-warning border border-warning border-dashed d-flex justify-content-center p-5 my-10'>
          <div className='d-flex flex-column text-center'>
            <h5 className='mb-1'>No shipping rates</h5>
            <span className='text-center'>
              There are no shipping methods available for the customer shipping address.
            </span>
          </div>
        </div>
      )}
      <ShippingMethodList deliveryMethod={rates} />
    </Card>
  )
}

export default ShippingMethods
